import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Correct imports
import Jepx_price from "./components/jepx_price";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Jepx_price />} />
      </Routes>
    </Router>
  );
}

export default App;